firebird.directive('camaroDetector', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'camaroDetector.html'),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
